module.exports = __webpack_public_path__ + "ui/img/screenshot-sample.7e7270bc.jpg";